import { render, staticRenderFns } from "./AllArticlesPage.vue?vue&type=template&id=995be35c&"
import script from "./AllArticlesPage.vue?vue&type=script&lang=js&"
export * from "./AllArticlesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports